export default __webpack_public_path__ + "static/move5000-eeea5ae6d62494d13b0663458cdb5afe.png";